<template>
  <div style="min-height: 700px">
    <CopyNotification
      :opened="copyConfirmVisible"
      :text="'zkopirovanoDoSchranky'"
      @close="copyConfirmVisible = false"
    />
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <div v-if="containsSuspensions" class="messages__suspended font-weight-bold">
          {{ $t("CONTAINS_SUSPENDED_MESSAGES") }}
          <a class="ml-2" @click="selectSuspended">
            {{ $t("zobrazit") }}
          </a>
        </div>
        <h3>{{ $t("vsechnyZpravy") }}</h3>

        <MessageFilter
          :all="allMessages"
          :count="allMessagesLength"
          :from="from"
          :fulltext-disabled="true"
          :no-type="false"
          :order-by="sort"
          :order-type="sortType"
          :rows="messages"
          :select-suspended="selectedSuspended"
          :to="to"
          :to-apply-filter="applyFilter"
          @filtered-items="filteredMessages"
          @reset-paging="page = 0"
          @reset-search="resetSearch"
          @selected-suspended="selectedSuspended = false"
          @set-from="setFrom"
          @set-to="setTo"
          @statuses-changed="selectedStatuses = $event"
          @types-change="selectedTypes = $event"
        />
      </div>

      <button
        class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
        @click="flushQueue()"
      >
        <div class="atom-icon m-0">
          <img src="@/assets/icons/actions/ico-ico-delete.svg" />
        </div>
        {{ $t("smazatFrontu") }}
      </button>
    </div>
    <div>
      <span
        v-if="!loadingData && messages.length > 0"
        id="exportbutton"
        class="link"
        @click="openedExportSelect = true"
      >
        {{ $t("exportZprav") }}
      </span>
      <div v-if="openedExportSelect" class="d-flex">
        <div :key="selectedTypes.length" v-tooltip :title="selectedTypes.length === 1 ? '' : $t('SELECT_ONE_TYPE')">
          <span
            id="exportbutton"
            :class="{ disabled: selectedTypes.length !== 1 }"
            class="btn btn-outline-gray btn-sm btn-outline-primary mt-2 d-flex align-items-center mr-1"
            @click="
              () => {
                openedExportSelect = false
                exportMessagesCsv()
              }
            "
          >
            {{ $t("CSV") }}
          </span>
        </div>
        <div :key="selectedTypes.length" v-tooltip :title="selectedTypes.length === 1 ? '' : $t('SELECT_ONE_TYPE')">
          <span
            id="exportbutton"
            :class="{ disabled: selectedTypes.length !== 1 }"
            class="btn btn-sm btn-outline-primary mt-2 d-flex align-items-center"
            @click="
              () => {
                openedExportSelect = false
                exportMessagesXlsx()
              }
            "
          >
            {{ $t("XLSX") }}
          </span>
        </div>
      </div>
    </div>
    <div class="border-top mt-3 pb-3" />
    <AppLoader v-if="loadingData" />
    <div v-if="!messages.length && !loadingData">
      {{ $t("zadneZpravyKZobrazeni") }}
    </div>
    <div v-if="messages.length > 0" class="position-relative w-100">
      <div id="messages" class="table-responsive">
        <table class="table-fixed table table-main table-hover">
          <thead>
            <tr>
              <th
                v-for="(column, index) in columns"
                :key="index"
                :style="{ width: column.minWidth }"
                :class="{ isHidden: !column.visible }"
              >
                <span v-if="column.type === 'ack'" class="d-flex align-items-start">
                  <span>{{ $t(column.name) }}</span>
                  <InfoExclamationMarkNoText info-tooltip="ACK_DESCRIPTION" />
                </span>
                <span v-else-if="column.sortable != true">
                  {{ $t(column.name) }}
                </span>
                <span v-else>
                  <div class="title" @click="sortMessagesBy(column.type)">
                    {{ $t(column.name) }}
                  </div>
                  <div v-if="sort == column.type" class="sorting">
                    <span v-if="sortType == 'desc'">▼</span>
                    <span v-if="sortType == 'asc'">▲</span>
                  </div>
                </span>
              </th>
              <th style="width: 75px" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, item_index) in messages.slice(
                this.page * Number(this.rowsPerPage),
                this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
              )"
              :key="item_index"
              :class="getRowClasses(item)"
            >
              <td
                v-for="(column, column_index) in columns"
                :key="column_index"
                :style="{ width: column.minWidth }"
                :class="{
                  isHidden: !column.visible
                }"
              >
                <span v-if="column.type == 'custDeviceName'">
                  <span
                    :style="{ maxWidth: column.minWidth }"
                    class="gray-text-light"
                    style="display: block; word-wrap: break-word"
                  >
                    {{ device.custDeviceName }}
                  </span>
                </span>
                <span v-else-if="column.type == 'type'">
                  <span>
                    <span v-if="item.type == 'up'">
                      <img src="@/assets/icons/arrows/ico-ico-zezarizeni.svg" class="mr-2" />
                      {{ $t("zeZarizeni") }}
                    </span>
                    <span v-else>
                      <img src="@/assets/icons/arrows/ico-ico-dozarizeni.svg" class="mr-2" />
                      {{ $t("doZarizeni") }}
                    </span>
                  </span>
                </span>

                <span v-else-if="column.type == 'messageTime'">
                  <span v-html="$filters.dateTime(item.messageTime)" />
                </span>
                <span v-else-if="column.type == 'state'">
                  <template v-if="item.type === 'up'">
                    <span v-if="item.messageStatus == 'suspended'" class="atom-tag atom-tag--muted">
                      {{ $t("MSG_SUSPENDED") }}
                    </span>
                    <span v-else-if="item.state === 'inFront'" class="atom-tag">
                      {{ $t("veFronte") }}
                    </span>
                    <span v-else-if="item.state == 'OK'" class="atom-tag atom-tag--success">OK</span>
                    <span v-else-if="item.state == 'TEST'" class="atom-tag atom-tag--success">TEST</span>
                    <span v-else class="atom-tag atom-tag--warning">?</span>
                  </template>
                </span>
                <div v-else-if="column.type == 'signal'">
                  <SnrIcon :last-message-in="item" />
                </div>
                <div v-else-if="column.type == 'port'">
                  <span v-if="item.message != null" class="font-weight-normal">
                    {{ item.message.port }}
                  </span>
                </div>
                <div v-else-if="column.type == 'fcnt'">
                  <span v-if="item.message != null" class="font-weight-normal">
                    {{ item.message.fcnt }}
                  </span>
                </div>
                <div v-else-if="column.type == 'data'" style="max-width: 400px">
                  <img v-if="item.message.encdata != null" src="@/assets/icons/ico-ico-enc-payload.svg" />
                  <div class="d-flex">
                    <div style="text-overflow: ellipsis; overflow: hidden">
                      {{ item.message.data != null ? item.message.data : item.message.encdata }}
                    </div>
                    <span
                      v-if="item.messageStatus !== 'suspended'"
                      class="ml-1 copy gray-text-light"
                      @click="copyToClipboard(item.message.data != null ? item.message.data : item.message.encdata)"
                    >
                      <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                    </span>
                    <span v-else class="text-muted">
                      {{ $t("MESSAGE_SUSPENDED") }}
                    </span>
                  </div>
                </div>
                <span v-else-if="column.type === 'ack'">
                  <span v-if="item.message.ack !== undefined">
                    {{ item.message.ack ? 1 : 0 }}
                  </span>
                </span>
                <span v-else>
                  {{ item[column.type] }}
                </span>
              </td>
              <td style="min-width: 75px" />
            </tr>
          </tbody>
        </table>

        <table
          :class="{ showShadow: showShadow }"
          class="table-fixed table table-hover fixed-first-column"
          :style="{ '--fixed-first-width': columns[0].minWidth }"
        >
          <thead>
            <tr>
              <th>
                <span v-if="columns[0].sortable != true">
                  {{ $t("device") }}
                </span>
                <span v-else class="d-flex align-items-center">
                  <div class="title" @click="sortMessagesBy(columns[0].type)">
                    {{ $t("device") }}
                  </div>
                  <div v-if="sort == columns[0].type" class="sorting">
                    <span v-if="sortType == 'desc'">▼</span>
                    <span v-if="sortType == 'asc'">▲</span>
                  </div>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, item_index) in messages.slice(
                this.page * Number(this.rowsPerPage),
                this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
              )"
              :key="item_index"
              :class="getRowClasses(item)"
            >
              <td :style="{ width: columns[0].minWidth }">
                <span
                  :style="{ maxWidth: columns[0].minWidth }"
                  class="gray-text-light"
                  style="display: block; word-wrap: break-word"
                >
                  {{ device.custDeviceName }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-hover fixed-last-column" :class="{ showShadow: showShadow }">
          <thead>
            <tr>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, item_index) in messages.slice(
                this.page * Number(this.rowsPerPage),
                this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
              )"
              :key="item_index"
              :class="getRowClasses(item)"
            >
              <td>
                <span class="link" @click="showMessage(item)">
                  {{ $t("zobrazit") }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="messages.length > 0" class="custom-table__footer d-flex align-items-center justify-content-between">
      <div class="custom-table__footer__actions align-items-center" />

      <Paging
        :page="{
          currentPage: page,
          rowsPerPage: rowsPerPage,
          itemsTotalCount: messages.length,
          itemsCount: messages.length
        }"
        @next-page="page++"
        @page="page = $event"
        @prev-page="page--"
        @rows-per-page="rowsPerPage = $event"
      />
    </div>
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :opened="openedError" :centered="true" :errors="errorsToTranslate" @close="openedError = false" />
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import axios from "axios"
import Paging from "@/components/paging/paging.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import MessageFilter from "@/components/filters/message-table-filter.vue"
import AppLoader from "@/components/loader.vue"
import CopyNotification from "@/components/notify/notify.vue"
import SnrIcon from "@/components/boxes/snrIcon.vue"
import InfoExclamationMarkNoText from "@/components/info/infoExclamationMarkNoText.vue"
import { mapMutations } from "vuex"

export default {
  components: {
    InfoExclamationMarkNoText,
    Paging,
    SnrIcon,
    MessageFilter,
    AppLoader,
    CopyNotification,
    ErrorModal
  },
  props: {
    items: Array,
    device: Object,
    deviceId: String,
    reloadDM: Boolean
  },
  data() {
    return {
      sort: "messageTime",
      sortType: "desc",
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      toggledAllRows: false,
      copyConfirmVisible: false,
      messages: [],
      from: "",
      to: "",
      inFront: [],
      allMessages: [],
      dateChanged: false,
      upMessagesLength: 0,
      downMessagesLength: 0,
      preloadedUpMessages: [],
      preloadedDownMessages: [],
      preloadedMessages: [],
      loadedComplete: false,
      applyFilter: false,
      openedExportSelect: false,
      loadingData: false,
      noMessages: false,
      tableWidth: 0,
      errorsToTranslate: [],
      openedError: false,
      columns: [
        {
          type: "custDeviceName",
          name: "device",
          sortable: false,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "messageTime",
          name: "messageTime",
          sortable: true,
          visible: true,
          minWidth: "180px",
          order: 2
        },
        {
          type: "type",
          name: "type",
          sortable: false,
          visible: true,
          minWidth: "120px",
          order: 3
        },
        {
          type: "state",
          name: "state",
          sortable: false,
          visible: true,
          minWidth: "60px",
          order: 4
        },
        {
          type: "signal",
          name: "signal",
          sortable: false,
          visible: true,
          minWidth: "60px",
          order: 5
        },
        {
          type: "port",
          name: "port",
          sortable: false,
          visible: true,
          minWidth: "60px",
          order: 6
        },
        {
          type: "ack",
          name: "Ack",
          sortable: false,
          visible: true,
          minWidth: "60px",
          order: 7
        },
        {
          type: "fcnt",
          name: "fcnt",
          sortable: false,
          visible: true,
          minWidth: "80px",
          order: 8
        },
        {
          type: "data",
          name: "Data",
          sortable: false,
          visible: true,
          // minWidth: "120px",
          order: 9
        }
      ],
      tableColumnsDefault: {
        messageTime: {
          show: true,
          order: 2,
          title: "messageTime"
        },
        type: {
          show: true,
          order: 3,
          title: "type"
        },
        state: {
          show: true,
          order: 4,
          title: "state"
        },
        signal: {
          show: true,
          order: 5,
          title: "signal"
        },
        port: {
          show: true,
          order: 6,
          title: "port"
        },
        ack: {
          show: true,
          order: 7,
          title: "Ack"
        },
        fcnt: {
          show: true,
          order: 8,
          title: "fcnt"
        },
        data: {
          show: true,
          order: 9,
          title: "Data"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false,
      selectedStatuses: [],
      selectedSuspended: false,
      selectedTypes: [],
      containsSuspensions: false
    }
  },
  computed: {
    allMessagesLength() {
      return this.upMessagesLength + this.downMessagesLength
    },
    dateChange() {
      const { to, from } = this
      return {
        from,
        to
      }
    },
    lastMessageIn() {
      return this.device.lastMessageIn
    },
    lastMessageOut() {
      return this.device.lastMessageOut
    },
    statusesForApi() {
      return this.selectedStatuses.map((s) => s.value).join("%2C")
    },
    lastMessages() {
      const { lastMessageIn, lastMessageOut } = this
      return {
        lastMessageIn,
        lastMessageOut
      }
    }
  },
  watch: {
    dateChange: {
      handler: function (val) {
        if (val.from != "1970-01-01T00:00:00.000Z") {
          this.setApplyFilter()
        }
      },
      deep: true
    },
    selectedStatuses() {
      this.setApplyFilter()
    },
    loadingData: {
      handler() {
        this.$nextTick(() => {
          this.updateResponsiveTable()
        })
      }
    },
    lastMessages: {
      handler() {
        this.reloadDeviceInfo()
      },
      deep: true
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    /*
    page() {
      this.isSelectedAllOnPage = false;
      var selectedDevices = this.allDevices.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      );
      let selectedDevicesId = selectedDevices.map(d => d.deviceId);
      let selectedAllRowsArray = Array.from(this.selectedRows);
      let allDevicesId = selectedAllRowsArray.map(d => d.deviceId);
      this.isSelectedAllOnPage = selectedDevicesId.every(ai =>
        allDevicesId.includes(ai)
      )
        ? true
        : false;
    },
    */
    messages() {
      this.inFront = _.filter(this.messages, ["state", "inFront"])
    },
    reloadDM() {
      if (this.reloadDM == true) {
        this.updateByLastMessage()
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    this.updateByLastMessage()
    if (localStorage.rowsPerPage) {
      var rows1 = localStorage.rowsPerPage
      this.rowsPerPage = rows1
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    this.updateResponsiveTable()
    this.checkSuspendedMessages()
  },
  methods: {
    ...mapMutations({
      setGlobalNotification: "modals/setGlobalNotification",
      setGlobalError: "modals/setError"
    }),
    selectSuspended() {
      this.selectedSuspended = true
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "messages")
    },
    toggleSendMessageModal() {
      this.$emit("toggleSendMessageModal", "sendMessage")
    },
    resetSearch() {
      let now = new Date()
      const dateTo = now
      const dateFrom = new Date(dateTo - 1 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    async updateByLastMessage() {
      this.noMessages = false
      let device = this.device

      if (device) {
        let useDate = device.lastMessageOut
        if (device.lastMessageIn > device.lastMessageOut) {
          useDate = device.lastMessageIn
        } else {
          useDate = device.lastMessageOut
        }
        if (device.lastMessageOut == null) {
          useDate = device.lastMessageIn
        }
        if (!device.lastMessageIn && !device.lastMessageOut) {
          this.noMessages = true
          let now = new Date()
          now.setHours(0, 0, 0, 0)
          useDate = now.toISOString()
        }

        const parsedTo = Date.parse(useDate)
        console.log("messages", "useDate" + useDate)
        let fr = String(this.from)
        let tt = String(this.to)
        if (this.from == "1970-01-01T00:00:00.000Z") {
          const dateFrom1 = new Date(parsedTo - 1 * 24 * 60 * 60 * 1000)
          dateFrom1.setHours(0, 0, 0, 0)
          this.from = dateFrom1.toISOString()
        } else if ((new Date(tt) - new Date(fr)) / 1000 / 60 / 60 / 24 > 30) {
          const dateFrom1 = new Date(parsedTo - 1 * 24 * 60 * 60 * 1000)
          dateFrom1.setHours(0, 0, 0, 0)
          this.from = dateFrom1.toISOString()
        }

        let dateTo = new Date(parsedTo)
        dateTo.setHours(23, 59, 59, 999)
        this.to = dateTo.toISOString()
        console.log("messages", "this.to" + this.to)
        this.$emit("setReloadDM", false)
      }
    },
    async reloadDevice() {
      return axios
        .get(process.env.VUE_APP_API + "/lora/devices/" + this.deviceId, {})
        .then((response) => {
          return response.data.data
        })
        .catch(() => {
          return true
        })
    },
    async reloadDeviceInfo() {
      return axios
        .get(process.env.VUE_APP_API + "/lora/devices/" + this.deviceId, {})
        .then((response) => {
          this.device = response.data.data
          this.this.setDateRange()
          return true
        })
        .catch(() => {
          return true
        })
    },
    async setApplyFilter() {
      this.page = 0
      this.applyFilter = false
      let messagesLoaded = await this.loadMessages()
      if (messagesLoaded) {
        this.applyFilter = true
        return true
      }
    },
    setDateRange() {
      let now = new Date()
      now.setHours(0, 0, 0, 0)
      const dateTo = now
      const dateFrom = new Date(dateTo - 31 * 24 * 60 * 60 * 1000)
      this.from = dateFrom.toISOString()
      this.to = now.toISOString()
    },
    async loadMessages() {
      if (this.loadingData) {
        return false
      }

      this.loadingData = true
      this.messages = []
      this.allMessages = []
      let upMessages = await this.loadUpMessages()
      let downMessages = await this.loadDownMessages()

      if (upMessages && downMessages) {
        this.loadingData = false
        let messages = [...this.preloadedUpMessages, ...this.preloadedDownMessages]
        let sorted = _.orderBy(messages, "messageTime", "desc")

        this.messages = sorted
        this.allMessages = sorted
        return true
      }
    },
    async loadUpMessages() {
      this.loadingData = true
      this.loadedComplete = false
      this.preloadedUpMessages = []
      this.errorsToTranslate = []
      return axios
        .get(
          `${process.env.VUE_APP_API}/lora/devices/${this.deviceId}/up/messages?from=${this.from}&to=${this.to}&limit=0&messageStatus[in]=${this.statusesForApi}`,
          {}
        )
        .then((result) => {
          let steps = Math.ceil(result.data.metadata.count / 1000)
          let promises = []
          for (let i = 0; i < steps; i++) {
            promises.push(
              axios
                .get(
                  `${process.env.VUE_APP_API}/lora/devices/${this.deviceId}/up/messages?from=${this.from}&to=${
                    this.to
                  }&limit=1000&offset=${i * 1000}&messageStatus[in]=${this.statusesForApi}`,
                  {}
                )
                .then((result) => {
                  console.log(result, "UPP MESSAGES")
                  this.upMessagesLength = result.data.data.length
                  result.data.data.forEach((message) => {
                    message.state = message.messageStatus === "preregistration" ? "TEST" : "OK"
                    message.type = "up"
                    message.snr = ""
                    message.rssi = ""
                    if (message.messageStatus == "preregistration") {
                      console.log(message, "PREREGMESS")
                    }
                    let gws = message.message.gws
                    if (gws != undefined) {
                      let sortedBySnr = _.orderBy(gws, "snr", "desc")
                      let largestSnr = sortedBySnr[0].snr
                      message.snr = largestSnr
                      let sortedByRssi = _.orderBy(gws, "rssi", "desc")
                      let largestRssi = sortedByRssi[0].rssi
                      message.rssi = largestRssi
                    }
                    this.preloadedUpMessages.push(message)
                  })
                })
                .catch((error) => {
                  let message = error.data.errors[0]
                  error.data.errors = []
                  error.data.errors.push({
                    message: message
                  })
                  this.loadingData = false
                  this.errorsToTranslate.push(error.data)
                })
            )
          }
          return Promise.all(promises).then(() => {
            this.$nextTick(() => {
              this.updateResponsiveTable()
            })
            return true
          })
        })
        .catch(() => {})
    },
    async loadDownMessages() {
      this.loadingData = true
      this.preloadedDownMessages = []
      this.errorsToTranslate = []
      let steps = 1
      let device = await this.reloadDevice()

      console.log("load messages from: " + this.from)
      console.log("load messages to: " + this.to)

      if (device) {
        for (let i = 0; i < steps; i++) {
          return axios
            .get(
              `${process.env.VUE_APP_API}/lora/devices/${this.deviceId}/down/messages?from=${this.from}&to=${this.to}&limit=1000&messageStatus[in]=${this.statusesForApi}`,
              {}
            )
            .then((result) => {
              if (steps == 1) {
                steps = Math.floor(result.data.metadata.count / result.data.metadata.result) + 1
              }
              this.downMessagesLength = result.data.data.length
              let counter = 0
              console.log(result.data, "DOWN MESSAGES")
              result.data.data.forEach((message) => {
                console.log(message.messageStatus, "STATUSSS")
                message.state = message.messageStatus === "preregistration" ? "TEST" : "OK"
                message.type = "down"
                message.fcnt = message.seqdn
                message.snr = ""
                message.rssi = ""

                counter++
                this.preloadedDownMessages.push(message)

                this.$nextTick(() => {
                  this.updateResponsiveTable()
                })
                if (i == steps) {
                  return true
                }
              })
              if (counter == result.data.metadata.count) {
                return true
              }
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message
              })
              this.loadingData = false
              this.errorsToTranslate.push(error.data)
            })
        }
      }
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = this.openedRowsSelect ? false : true
    },
    filteredMessages(messages) {
      if (messages != undefined) {
        this.messages = messages
      }
    },
    sortMessagesBy(sortBy) {
      let sorted
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.messages, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.messages, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.messages = sorted
    },
    copyToClipboard(text) {
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    setTo(to) {
      if (to != "1970-01-01T00:00:00.000Z") {
        let t = new Date(Date.parse(to))
        t.setHours(23, 59, 59, 999)
        this.to = t.toISOString()
      } else {
        this.to = to
      }
    },
    setFrom(from) {
      if (from != "1970-01-01T00:00:00.000Z") {
        let f = new Date(Date.parse(from))
        f.setHours(0, 0, 0, 0)
        this.from = f.toISOString()
      } else {
        this.from = from
      }
    },
    showMessage(message) {
      this.$emit("showMessage", message)
    },
    async exportMessagesCsv() {
      this.errorsToTranslate = []

      if (this.selectedTypes.length !== 1) {
        return 0
      }

      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API}/lora/devices/${this.device.deviceId}/${this.selectedTypes[0]}/messages?from=${this.from}&to=${this.to}&messageStatus[in]=${this.statusesForApi}&limit=50000`,
          {
            headers: {
              Accept: "text/csv"
            }
          }
        )
        const fileName = "messagesExport"
        const blob = new Blob([res.data], {
          type: "text/csv;charset=utf-8;"
        })
        if (window.navigator.msSaveBlob) {
          // FOR IE BROWSER
          navigator.msSaveBlob(blob, fileName)
        } else {
          // FOR OTHER BROWSERS
          var csvUrl = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.setAttribute("href", csvUrl)
          link.setAttribute("download", fileName)
          link.click()
          this.$store.commit("modals/setWaitingLoader", "")
        }
      } catch (error) {
        if (error.status) {
          let err = []
          err.errors = []
          err.errors.push({
            message: error.status + " " + error.statusText
          })
          this.errorsToTranslate.push(err)
          if (this.errorsToTranslate.length > 0) {
            this.openedError = true
          }
        }
        this.$store.commit("modals/setWaitingLoader", "")
      }
    },
    async exportMessagesXlsx() {
      this.errorsToTranslate = []

      if (this.selectedTypes.length !== 1) {
        return 0
      }

      this.$store.commit("modals/setWaitingLoader", this.$t("Exportuji data, čekejte prosím..."))

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API}/lora/devices/${this.device.deviceId}/${this.selectedTypes[0]}/messages?from=${this.from}&to=${this.to}&messageStatus[in]=${this.statusesForApi}&limit=50000`,
          {
            headers: {
              Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            },
            responseType: "arraybuffer"
          }
        )

        if (data !== undefined) {
          var fileName, blob
          let f = new Date(Date.parse(this.from) + 2 * 60 * 60 * 1000)
          let t = new Date(Date.parse(this.to) + 2 * 60 * 60 * 1000)
          let dateFrom = f.toISOString()
          let dateTo = t.toISOString()
          dateFrom = dateFrom.split("T")
          dateTo = dateTo.split("T")
          dateFrom = dateFrom[0].split("-")
          dateTo = dateTo[0].split("-")
          let fileNameSuffix =
            "_" +
            this.deviceId +
            "_" +
            dateFrom[0] +
            dateFrom[1] +
            dateFrom[2] +
            "_" +
            dateTo[0] +
            dateTo[1] +
            dateTo[2]

          fileName = "export" + fileNameSuffix + ".xlsx"

          blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          })

          if (window.navigator.msSaveBlob) {
            // FOR IE BROWSER
            navigator.msSaveBlob(blob, fileName)
          } else {
            // FOR OTHER BROWSERS
            var csvUrl = URL.createObjectURL(blob)
            const link = document.createElement("a")
            link.setAttribute("href", csvUrl)
            link.setAttribute("download", fileName)
            link.click()
            this.$store.commit("modals/setWaitingLoader", "")
          }
        }
      } catch (error) {
        if (error.status) {
          let err = []
          err.errors = []
          err.errors.push({
            message: error.status + " " + error.statusText
          })
          this.errorsToTranslate.push(err)
          if (this.errorsToTranslate.length > 0) {
            this.openedError = true
          }
        }
        this.$store.commit("modals/setWaitingLoader", "")
      }
    },
    async flushQueue() {
      axios
        .post(process.env.VUE_APP_API + "/lora/devices/" + this.deviceId + "/flush-queue", {})
        .then((res) => {
          if (res.data.status === "success") {
            this.setGlobalNotification({
              text: "NOTIFICATION_QUEUE_FLUSHED"
            })
            this.updateByLastMessage()
          } else if (res.data.errors?.length) {
            this.setGlobalError(this.$t(res.data.errors[0]))
          }
        })
        .catch(() => {})
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length === 0) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    },
    async checkSuspendedMessages() {
      const upMessages = await axios.get(
        `${process.env.VUE_APP_API}/lora/devices/${this.deviceId}/up/messages?from=${this.from}&to=${this.to}&limit=1&messageStatus[in]=suspended`,
        {}
      )
      if (upMessages.data.metadata.count) {
        this.containsSuspensions = true
      }
    },
    getRowClasses(row) {
      if (row.type === "down") {
        return null
      }

      return {
        "blue-light-bg": row.message.confirmed,
        "blue-bg": row.state === "inFront",
        "grey-bg": row.messageStatus === "suspended"
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
